import { Components } from '@mui/material';
import { getDenseResponsiveFontSize } from '../watchdutyTheme.utils';

/** Field helper / error text — dense UI; stays at design size under large system text. */
export const MuiFormHelperText: Components['MuiFormHelperText'] = {
  styleOverrides: {
    root: {
      fontSize: getDenseResponsiveFontSize('0.75rem'),
      lineHeight: 'normal',
    },
  },
};
